/* eslint-disable */
export default {
  eula: 'Licentieovereenkomst voor eindgebruikers',
  eulaAbbr: 'EULA',
} as const;

// @key: @#@"eula"@#@ @source: @#@"End User License Agreement"@#@
// @key: @#@"eulaAbbr"@#@ @source: @#@"EULA"@#@
